import { FetchStatus, QueryType } from "../../../../base/types";

import { IPage } from "../../models";
import { Pagination } from "../../../../widgets";
import { ViewPageControls } from "./ViewPageControls";
import { useDataContext } from "../../context/DataContextProvider";

export const ListPage = ({ page, className }: {
    page: IPage,
    className?: string
}) => {
    return (
        <div className={className}>
            <ViewPageControls controls={page.controls} />
            {(page.pagination) &&
                <ListPagePagination page={page} />}
        </div>)
}

export const ListPagePagination = ({ page }: {
    page: IPage,
}) => {
    const { queryOptions, goto } = useDataContext()
    const { type, result: data, status } = useDataContext();

    if (status !== FetchStatus.Success ||
        type !== "List" ||
        !queryOptions ||
        queryOptions.queryType !== QueryType.MultipleRecords
    )
        return <></>

    const { pageNo } = queryOptions.query

    return <Pagination
        records={data.count || 0}
        curPageNo={pageNo || 0}
        pageSize={page.recordLimit}
        onChange={(pageNo) => goto(pageNo)} />
}